import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import documentBlueprintKeys from '@/api/queries/documentBlueprints/keyFactory';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  CloneDocumentBlueprintMutation,
  CloneDocumentBlueprintMutationVariables,
} from '@/gql/graphql';

const CloneDocumentBlueprint = graphql(`
  mutation CloneDocumentBlueprint($blueprintId: ID!) {
    cloneDocumentBlueprint(blueprintId: $blueprintId) {
      fieldGroup {
        id
      }
      documentTemplate {
        id
      }
    }
  }
`);

const useCloneDocumentBlueprint = (
  options?: UseMutationOptions<
    CloneDocumentBlueprintMutation,
    unknown,
    CloneDocumentBlueprintMutationVariables['blueprintId']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (blueprintId) =>
      gqlClient.request(CloneDocumentBlueprint, { blueprintId }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.customFieldGroups(),
      });
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplates(),
      });
      void queryClient.invalidateQueries({
        queryKey: documentBlueprintKeys.all,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCloneDocumentBlueprint;
